// extracted by mini-css-extract-plugin
export var legendIndicator = "_90-1";
export var legendRight = "_90-0";